// Shared animation tokens and small helpers for Cover Pages
// Keep durations short and subtle; respect reduced motion when possible.

export const EASE_BEZIER = [0.25, 0.46, 0.45, 0.94] as const

export const ANIMATION_DURATION = {
  move: 0.25,
  fade: 0.25,
  stagger: 0.15
}

export const prefersReducedMotion = (): boolean =>
  typeof window !== "undefined" &&
  !!window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches

export type FadeOptions = {
  distance?: number
  duration?: number
}

// Basic fade in with a tiny upward motion; suitable for headers and controls
export const fadeInUp = ({
  distance = 8,
  duration = ANIMATION_DURATION.fade
}: FadeOptions = {}) => ({
  initial: prefersReducedMotion()
    ? { opacity: 0 }
    : { opacity: 0, y: distance },
  animate: prefersReducedMotion()
    ? { opacity: 1 }
    : { opacity: 1, y: 0 },
  exit: prefersReducedMotion() ? { opacity: 0 } : { opacity: 0, y: distance },
  transition: { duration, ease: EASE_BEZIER }
})

// Simple crossfade helper
export const fade = (duration = ANIMATION_DURATION.fade) => ({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration, ease: EASE_BEZIER }
})
